import { Outlet } from 'react-router-dom'
import React from 'react'
import Header from './Common/Header/Header'
import { Footer } from './Common/Footer/Footer'

/**
 * The layout previously gated the entire site behind a hard-coded 2 second
 * <Loader />:
 *
 *   const [loading, setLoading] = useState(true);
 *   useEffect(() => { setTimeout(() => setLoading(false), 2000); });
 *
 * That was removed for three reasons:
 *
 *  1. It made prerendering impossible. Any snapshot of a route captured the
 *     spinner rather than the page, so the generated HTML would have carried
 *     no indexable content at all.
 *  2. The effect had no dependency array, so it re-armed a fresh 2s timer on
 *     every single render.
 *  3. It delayed first contentful paint by 2s for every real visitor while
 *     waiting on nothing — it was not tied to any data fetch.
 *
 * Pages that genuinely wait on an API call still render their own loading
 * state (e.g. PrivacyPolicy), so no real loading feedback was lost.
 */
export const MainLayout = () => {
    return (
        <div id='wrapper'>
            <div id='content-wrapper' className='d-flex flex-column'>
                <div id='content'>
                    <Header />
                    <Outlet />
                </div>
                <Footer />
            </div>
        </div>
    )
}
